// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-item {
	text-align: center;
}

.contact-us {
    background-color: #7d7777;
    color: #fff;
    font-size: 1.5rem;
    color: #959090;
}


.contact-us {
    background-color: #060000;
    padding: 50px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Home.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".contact-item {\n\ttext-align: center;\n}\n\n.contact-us {\n    background-color: #7d7777;\n    color: #fff;\n    font-size: 1.5rem;\n    color: #959090;\n}\n\n\n.contact-us {\n    background-color: #060000;\n    padding: 50px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
